module.exports = __webpack_public_path__ + "static/little-devils-logo-0fc0923006a7ef101f4b4450ed709d63.png";